<div class="flex flex-col gap-4">
    <div class="text-14 leading-[normal] text-muted-color font-inter"
        >{{ selectedSessions.length }}
        {{ selectedSessions.length === 1 ? 'Session' : 'Sessions' }} Selected</div
    >
    <div class="flex flex-col gap-2">
        @for (session of selectedSessions; track session.sessionTime) {
            <fm-selected-sessions-list-item
                [sessionInfo]="session"
                [user]="userService.currentUser | async" />
        }
    </div>
</div>
